import { GetterTree } from 'vuex'
import { AttachmentState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<AttachmentState, RootState> = {
  fileCount: (state: AttachmentState) =>
    state.buildingLocationFilesInfo.length
}
